import React, { useState } from "react";
import { elakayAutoText } from "../dataElakay";
import "./CartCheckin.css";

// Cart lines the server no longer offers for sale (GET /user/cart -> unavailable):
// deleted, deleted by their Provider (Dropshipping In), or switched off. They are
// never priced, totalled or charged -- this only tells the buyer why they are gone.
const REASON = {
  PROVIDER_DELETED: () => elakayAutoText("h_ptr_unavailable_deleted", "Product unavailable — Deleted by Provider"),
  DELETED: () => elakayAutoText("h_cartun_deleted", "No longer sold"),
  UNAVAILABLE: () => elakayAutoText("h_cartun_unavailable", "Currently unavailable"),
  VARIANT_UNAVAILABLE: () => elakayAutoText("h_ckin_issue_variant", "This option is no longer available"),
};

export default function CartUnavailableNotice({ lines, onRemove }) {
  const [removing, setRemoving] = useState(null);
  const list = Array.isArray(lines) ? lines : [];
  if (!list.length) return null;
  return (
    <div className="cki-alert cki-alert--warn cart-unavailable" role="status" data-testid="cart-unavailable">
      <strong>{elakayAutoText("h_cartun_title", "Some products in your cart are no longer available")}</strong>
      <ul className="cart-unavailable__list">
        {list.map((line) => (
          <li key={line.cartItemId}>
            {line.name || elakayAutoText("h_cartun_unnamed", "Product")} — {(REASON[line.reason] || REASON.UNAVAILABLE)()}
            {onRemove && (
              <button type="button" className="cart-unavailable__remove" disabled={removing === line.cartItemId}
                onClick={async () => { setRemoving(line.cartItemId); try { await onRemove(line.cartItemId); } finally { setRemoving(null); } }}>
                {elakayAutoText("h_cartun_remove", "Remove")}
              </button>
            )}
          </li>
        ))}
      </ul>
      <small>{elakayAutoText("h_cartun_not_charged", "They are not included in your total and will not be charged.")}</small>
    </div>
  );
}
